import { render } from "./RatingControl.vue?vue&type=template&id=5ebad62d&scoped=true"
import script from "./RatingControl.vue?vue&type=script&lang=js"
export * from "./RatingControl.vue?vue&type=script&lang=js"

import "./RatingControl.vue?vue&type=style&index=0&id=5ebad62d&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\voting2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebad62d"]])

export default __exports__